import { ReactComponent as CloneAccess } from './clone-access.svg'

export default CloneAccess
